export default __webpack_public_path__ + "static/media/benefits.7a96a484.png";